import {
  Component,
  OnDestroy,
  OnInit,
  computed,
  inject,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  Subject,
  filter,
  take,
  takeUntil
} from 'rxjs';
import {
  ClientsService,
  SelectedClient,
} from 'src/app/services/clients/clients.service';
import { ClientOption } from 'src/app/shared/payee-cases/types';
import { PayeeCasesComponent } from '../../../shared/payee-cases/payee-cases.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss'],
  imports: [HeaderComponent, PayeeCasesComponent, TranslateModule],
})
export class CasesComponent implements OnInit, OnDestroy {
  private clientsService = inject(ClientsService);
  private readonly destroy = new Subject<void>();

  readonly getCasesPath: string = `api/case`;
  readonly getDebtorsPath: string = `api/debtor`;
  showCasesTable = signal(false);

  private readonly hasMultipleClients = signal(false);

  readonly showClientColumn = computed(() => this.hasMultipleClients());

  readonly searchClients = async (name: string): Promise<ClientOption[]> => {
    const clients = this.clientsService.clientsSubject.value ?? [];
    const needle = name.toLowerCase();
    return clients
      .filter((c) => (c.name ?? '').toLowerCase().includes(needle))
      .map(
        (c): ClientOption => ({
          uuid: c.id,
          name: c.name ?? '',
        }),
      );
  };

  readonly resolveClient = async (
    uuid: string,
  ): Promise<ClientOption | null> => {
    const clients = this.clientsService.clientsSubject.value ?? [];
    const client = clients.find((c) => c.id === uuid);
    if (!client) {
      return null;
    }
    return {
      uuid: client.id,
      name: client.name ?? '',
    };
  };

  ngOnInit(): void {
    this.clientsService.clientsSubject
      .pipe(
        takeUntil(this.destroy),
        filter((clients): clients is SelectedClient[] => !!clients?.length),
        take(1),
      )
      .subscribe((clients) => {
        this.hasMultipleClients.set(clients.length > 1);
        this.showCasesTable.set(true);
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }
}
